// src/contexts/WebSocketContext.jsx
import React, { createContext, useContext, useEffect } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { toast } from 'sonner';

const WebSocketContext = createContext();

export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocketContext must be used within WebSocketProvider');
  }
  return context;
};

export const WebSocketProvider = ({ children }) => {
  const webSocket = useWebSocket();
  
  // Global message handler for notifications
  useEffect(() => {
    if (!webSocket.isConnected) return;
    
    const unsubscribe = webSocket.addMessageHandler('notification', (data) => {
      if (data.message) {
        toast.info(data.message, {
          duration: 4000
        });
      }
    });
    
    return unsubscribe;
  }, [webSocket.isConnected, webSocket.addMessageHandler]);
  
  return (
    <WebSocketContext.Provider value={webSocket}>
      {children}
    </WebSocketContext.Provider>
  );
};